var e = class extends HTMLElement {
  constructor() {
    super(), this.detailsContainer = this.querySelector(`details`), this.summaryToggle = this.querySelector(`summary`), this.detailsContainer.addEventListener(`keyup`, (e2) => e2.code.toUpperCase() === `ESCAPE` && this.close()), this.summaryToggle.addEventListener(`click`, this.onSummaryClick.bind(this)), this.querySelector(`button[type="button"]`).addEventListener(`click`, this.close.bind(this)), this.summaryToggle.setAttribute(`role`, `button`);
  }
  isOpen() {
    return this.detailsContainer.hasAttribute(`open`);
  }
  onSummaryClick(e2) {
    e2.preventDefault(), e2.target.closest(`details`).hasAttribute(`open`) ? this.close() : this.open(e2);
  }
  onBodyClick(e2) {
    (!this.contains(e2.target) || e2.target.classList.contains(`modal-overlay`)) && this.close(false);
  }
  open(e2) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this), e2.target.closest(`details`).setAttribute(`open`, true), document.body.addEventListener(`click`, this.onBodyClickEvent), document.body.classList.add(`overflow-hidden`), trapFocus(this.detailsContainer.querySelector(`[tabindex="-1"]`), this.detailsContainer.querySelector(`input:not([type="hidden"])`));
  }
  close(e2 = true) {
    removeTrapFocus(e2 ? this.summaryToggle : null), this.detailsContainer.removeAttribute(`open`), document.body.removeEventListener(`click`, this.onBodyClickEvent), document.body.classList.remove(`overflow-hidden`);
  }
};
customElements.define(`details-modal`, e);
//# sourceMappingURL=details-modal.js.map
